export const createRowId = <TData>(row: TData, index: number): string => {
  if (row && typeof row === "object") {
    try {
      // Try to create a consistent hash from the object properties
      const objEntries = Object.entries(row)
        .filter(([_, value]) => value !== undefined && value !== null)
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));

      const stableString = objEntries
        .map(([key, value]) => `${key}:${String(value)}`)
        .join("|");

      let hash = 0;
      for (let i = 0; i < stableString.length; i++) {
        const char = stableString.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }

      return `${hash}_${index}`;
    } catch {
      // Fall back to index-based ID if hashing fails
      return `row_${index}`;
    }
  }

  // Default to index-based ID
  return `row_${index}`;
};
